import { HttpClient, HttpContext, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { MedicoConflitoInteresseResponse, MedicoNaturezaVinculoResponse } from '@/core/api/sicom-api/registro/medico/conflito-interesse/conflito-interesse.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '@env/environment';
import { getConflitoInteresse, getConflitoInteresseInativo, getNaturezasVinculo } from '@/core/api/sicom-api/registro/medico/conflito-interesse/api/conflito-interesse-api-get';
import { conflitoInteresseUpsert } from '@/core/api/sicom-api/registro/medico/conflito-interesse/api/conflito-interesse-api-upsert';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class ConflitoInteresseService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }
    readonly PATH = SICOM_PATHS.registro.medico.conflitoInteresse.base;

    buscar(params: Pessoa, context?: HttpContext): Observable<MedicoConflitoInteresseResponse[]> {
        // Usa helper com rootUrl para garantir que as chamadas vão para o host da API
        return getConflitoInteresse(this.http, this.rootUrl, params, context).pipe(map((r: any) => r.body as MedicoConflitoInteresseResponse[]));
    }

    buscarInativo(params: Pessoa, context?: HttpContext): Observable<MedicoConflitoInteresseResponse[]> {
        return getConflitoInteresseInativo(this.http, this.rootUrl, params, context).pipe(map((r: any) => r.body as MedicoConflitoInteresseResponse[]));
    }

    /**
     * Listar Naturezas de Vínculo disponíveis para Conflito de Interesse.
     * GET /api/v1/cadastro/medico/conflito-interesse/naturezas-vinculo
     */
    listarNaturezasVinculo(context?: HttpContext): Observable<MedicoNaturezaVinculoResponse[]> {
        return getNaturezasVinculo(this.http, this.rootUrl, context).pipe(map((r: any) => r.body as MedicoNaturezaVinculoResponse[]));
    }

    /**
     * Criar ou atualizar Conflito de Interesse
     * POST /api/v1/cadastro/medico/conflito-interesse
     * - Retorna true quando criado (201) ou atualizado (200)
     * - Para 409 (conflito/validação) retorna false
     */
    upsertConflitoInteresse(body: MedicoConflitoInteresseResponse, context?: HttpContext): Observable<boolean> {
        return conflitoInteresseUpsert(this.http, this.rootUrl, body, context).pipe(
            map((r: any) => {
                const status = r.status as number;
                return status === 200 || status === 201;
            }),
            catchError((e: HttpErrorResponse) => {
                if (e.status === 409) {
                    return of(false);
                }
                return throwError(() => e);
            })
        );
    }
}
